import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { User } from '../../types';
import styles from '../../styles/MobileNav.module.css';

interface MobileNavProps {
  isOpen: boolean;
  onClose: () => void;
  user: User | null;
}

const MobileNav: React.FC<MobileNavProps> = ({ isOpen, onClose, user }) => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: 'home' },
    { path: '/wallet', label: 'My Wallet', icon: 'wallet' },
    { path: '/my-groups', label: 'My Groups', icon: 'groups' },
    { path: '/task-management', label: 'Task Management', icon: 'tasks' },
    { path: '/my-activity', label: 'My Activity', icon: 'activity' },
    { path: '/badges', label: 'Badges', icon: 'badge' },
    { path: '/notifications', label: 'Notifications', icon: 'notifications' },
    { path: '/profile', label: 'Profile', icon: 'profile' },
  ];

  const getIcon = (iconName: string) => {
    const icons: { [key: string]: string } = {
      home: 'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z M9 22V12h6v10 M12 12h3',
      wallet: 'M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z',
      groups: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2 M9 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8 M23 21v-2a4 4 0 0 0-3-3.87 M16 3.13a4 4 0 0 1 0 7.75',
      tasks: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6 M16 13H8 M16 17H8 M10 9H8',
      activity: 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z',
      badge: 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z',
      notifications: 'M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9 M13.73 21a2 2 0 0 1-3.46 0',
      profile: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2 M12 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8',
    };
    return icons[iconName] || icons.home;
  };

  const handleLinkClick = () => {
    onClose();
  };

  return (
    <>
      {/* Overlay */}
      <div 
        className={`${styles.navOverlay} ${isOpen ? styles.active : ''}`}
        onClick={onClose}
      />

      {/* Mobile Navigation */}
      <div className={`${styles.sideBarContent} ${isOpen ? styles.active : ''}`}>
        <div className={styles.sideBarImage}>
          <div className={styles.logo}>
            <Link to="/dashboard" onClick={handleLinkClick}>
              <img src="/images/wallet-transparent.png" alt="WorkWallet" style={{ height: '28px' }} />
              WorkWallet
            </Link>
          </div>
        </div>

        <nav className={styles.mobileNav}>
          {navItems.map((item, index) => (
            <Link
              key={index}
              to={item.path}
              className={`${styles.mobileNavLink} ${isActive(item.path) ? styles.active : ''}`}
              onClick={handleLinkClick}
            >
              <div className={styles.navIconContainer}>
                <svg className={styles.navIcon} viewBox="0 0 24 24">
                  <path d={getIcon(item.icon)} />
                </svg>
              </div>
              <span className={styles.navLabel}>{item.label}</span>
            </Link>
          ))}
        </nav>
      </div>
    </>
  );
};

export default MobileNav;
